import api from '../lib/api';

const engagementService = {
  clap: (articleId) => api.post(`/articles/${articleId}/clap`),
  removeClap: (articleId) => api.delete(`/articles/${articleId}/clap`),
  trackView: (articleId) => api.post(`/articles/${articleId}/view`),
  trackShare: (articleId, platform) => api.post(`/articles/${articleId}/share`, { platform }),
  getComments: (articleId) => api.get(`/articles/${articleId}/comments`),
  addComment: (articleId, data) => api.post(`/articles/${articleId}/comments`, data),
  deleteComment: (commentId) => api.delete(`/comments/${commentId}`),
  updateComment: (commentId, content) => api.put(`/comments/${commentId}`, { content }),
  likeComment: (commentId) => api.post(`/comments/${commentId}/like`),
  removeCommentLike: (commentId) => api.delete(`/comments/${commentId}/like`),
  bookmarkArticle: (articleId) => api.post(`/articles/${articleId}/bookmark`),
  removeBookmark: (articleId) => api.delete(`/articles/${articleId}/bookmark`),
};

export default engagementService;
